










































































import Vue from 'vue';
import { Refs } from '@/types';
import { mapActions } from 'vuex';
import Component from 'vue-class-component';
import { SaisieInfosPatient, SaisieInfosContact, NonRGFrancais } from '@/components/SaisiePatientManuelle';
import { SaisieInfosPatientType, SaisieInfosContactType } from '@/components/SaisiePatientManuelle/types';
import { VaccinationFolder, FolderUpdate } from '@/store/folder/types';
import ValidationBtns from '@/components/ValidationBtns';
import { changeFormatDateString, formatDateWithOrigin } from '@/services/dateFormatter';
import _ from 'lodash';
import { Getter } from 'vuex-class';
import { updateFolder } from '@/services/api/save/api';
import { ParametresUtilisateur } from '@/store/parametresUtilisateur/types';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { adapteFormVaccinateurPs } from '@/components/Vaccination/InformationsVaccin/adapter';

const Props = Vue.extend({
	props: {
		prescriptionId: {
			type: Number,
			default: null
		}
	}
});

@Component({
	components: {
		SaisieInfosContact,
		SaisieInfosPatient,
		ValidationBtns,
		NonRGFrancais
	},
	methods: {
		...mapActions('globalState', ['addLoading', 'removeLoading'])
	}
})
export default class IdentificationModification extends Props {
	@Getter('infosVaccinationFolder/getVaccinationFolder') folder: VaccinationFolder | undefined;
	@Getter('infosPSBEN/getInfosPSBEN') infosPsben!: InfosPSBEN;
	@Getter('parametresUtilisateur/getParametresUtilisateur') parametresUtilisateur!: Map<string, ParametresUtilisateur>;

	$refs!: Refs<{
		saisieContact: SaisieInfosContact;
		saisiePatient: SaisieInfosPatient;
		nonRGFrancais: NonRGFrancais;
	}>;
	listBlocsKO: Vue[] = [];

	infosPatient: SaisieInfosPatientType | undefined = undefined;
	infosContact: SaisieInfosContactType | undefined = undefined;
	codeErreur = '';
	isErreur = false;
	isNonRGFrancaisChecked = true;

	cleanError() {
		this.codeErreur = '';
		this.isErreur = false;
	}

	get hasCodeErreur() {
		return !_.isNil(this.codeErreur) && this.codeErreur !== '';
	}

	get isEmergencyMode() {
		return _.isEmpty(this.folder?.nirBeneficiaire);
	}

	get blocTitle() {
		return this.isEmergencyMode ? 'Identifier un patient non affilié au régime d’assurance maladie français' : 'Identifier un patient';
	}

	validerFormulairePatient() {
		this.cleanError();
		this.checkFormValidity().then((response) => {
			if (response) {
				this.addLoading();
				const infosPatient: SaisieInfosPatientType = this.$refs.saisiePatient.getInfosPatient();
				const parametresUtilisateur =
				this.parametresUtilisateur.get(_.get(this.infosPsben, 'ps.numRPPS')) as ParametresUtilisateur;
				const psDelegation = _.get(parametresUtilisateur, 'delegation');
				const ps = this.parametresUtilisateur.get(_.get(this.infosPsben, 'ps.numRPPS'));
				updateFolder(this.folder?.numeroBon,
						this.buildUpdateFolder(infosPatient),
						psDelegation,
						adapteFormVaccinateurPs(this.infosPsben, ps),
						this.folder?.prescription?.prescriptionId
					).then((responseApi) => {
						const errorCode = _.get(responseApi, 'data.value.errorCode');
						if (_.isEmpty(errorCode)) {
							this.$store.dispatch('infosVaccinationFolder/updateFolderAndFlags', responseApi);
							this.goToDeclaration();
						} else {
							this.codeErreur = errorCode;
							this.isErreur = true;
						}
						this.removeLoading();
					});
			} else {
				// On remonte au premier bloc non validé
				if (this.listBlocsKO.length !== 0) {
					const blocKO: any = this.listBlocsKO[0].$el;
					window.scrollTo(0, blocKO.offsetTop);
				}
			}
		});
	}

	goToDeclaration(): void {
		this.$router.push({
			name: 'declaration',
			query: Object.assign({}, this.$router.currentRoute.query)
		});
	}

	checkFormValidity() {
		return new Promise((resolve, reject) => {
			this.checkPatientFormValidity().then((patientFormResp: boolean) => {
				if (this.isEmergencyMode) {
					this.checkNonRGFrancaisCheckboxValidity().then((nonRGFrancaisResp: boolean) => {
						resolve(patientFormResp && nonRGFrancaisResp);
					});
				} else {
					resolve(patientFormResp);
				}
			});
		});
	}

	checkNonRGFrancaisCheckboxValidity(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			// Validation de la checkbox non régime français
			this.$refs.nonRGFrancais.validerNonRGFrancais().then((result: boolean) => {
				// ajout à la liste des block en erreur
				if (!result) {
					this.listBlocsKO.push(this.$refs.nonRGFrancais);
				}
				resolve(result);
			});
		});
	}

	checkPatientFormValidity(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			// Validation du formulaire de prescription
			this.$refs.saisiePatient.validerSaisiePatientForm().then((result: boolean) => {
				// ajout à la liste des block en erreur
				if (!result) {
					this.listBlocsKO.push(this.$refs.saisieContact);
				}
				resolve(result);
			});
		});
	}

	buildUpdateFolder(infosPatient: SaisieInfosPatientType): FolderUpdate {
		const formatDate = formatDateWithOrigin(infosPatient.dateNaissance, 'DD/MM/YYYY', 'YYYYMMDD');
		return {
			nomAssure: infosPatient.nomUsage,
			prenomAssure: infosPatient.prenom,
			nomPatronymiqueAssure : infosPatient.nomFamille,
			nomBeneficiaire: infosPatient.nomUsage,
			prenomBeneficiaire: infosPatient.prenom,
			nomPatronymiqueBeneficiaire: infosPatient.nomFamille,
			dateNaissanceBeneficiaire: formatDate,
			rangBeneficiaire: infosPatient.rang,
			sexeBeneficiaire: infosPatient.sexeBeneficiaire
		};
	}

	created() {
		if (this.folder) {
			const dateNaissance = changeFormatDateString(this.folder?.dateNaissanceBeneficiaire, 'YYYYMMDD', 'DD/MM/YYYY');
			this.infosContact = {
				hebergeant: this.folder.adresseL2,
				email: this.folder.email,
				telephone: this.folder.telephonePortable,
				voie: this.folder.adresseL4,
				complementAdresse: this.folder.adresseL3,
				lieuDit: this.folder.adresseL5,
				codePostal: this.folder.codePostal,
				localite: this.folder.bureauDistributeur
			};
			this.infosPatient = {
				nir: this.folder.nirBeneficiaire,
				sexeBeneficiaire: this.folder.sexeBeneficiaire,
				nomFamille: this.folder.nomPatronymiqueBeneficiaire,
				nomUsage: this.folder.nomBeneficiaire,
				prenom: this.folder.prenomBeneficiaire,
				dateNaissance,
				rang: this.folder.rangBeneficiaire
			};
		}
	}
}
